import api from '../../plugins/api';

const editAdditionalServices = ({ id, title, price }) => {
  return api.post('api/crm/additional-services/editAdditionalService', { id, title, price });
};

export default editAdditionalServices;
